import { useAuth } from '../../../use';
import { odata } from '../../conf';
import Actions from '../../odata/actions';

const auth = useAuth();
const actions = new Actions('interviewAnswer', 'interviewAnswers');

const customActions = {
  async LOAD_interviewAnswersByInterview({ commit, rootGetters }, id) {
    const token = await auth.getAccessToken();
    const data = await odata.o(rootGetters, token)
      .get('interviewAnswers')
      .query({ $filter: `IsDeleted eq false AND InterviewId eq ${id}` });
    commit('SET_interviewAnswers', data);
    return data;
  },
};

export default { ...actions, ...customActions };
